<!--
 * @Author: LiuChuanQi
 * @Date: 2022-11-28 17:08:19
 * @LastEditTime: 2023-03-02 14:36:40
 * @LastEditors: LiuChuanQi
 * @Description: 短信登录模式
 * @FilePath: \speedtest-bigdata-v2\src\components\common\login\SmsType.vue
 *
-->
<template>
  <div class="sms">
    <div class="tip-infor">验证即登录，未注册将自动创建帐号</div>
    <div class="input-item1">
      <input
          type="text"
          class="phone"
          :class="{'error':phoneMessage}"
          @blur="blurPhone"
          @input="phoneInput"
          v-model="phone"
          placeholder="手机号"
      >
      <div class="bottom-tip">{{ phoneMessage }}</div>
    </div>
    <div class="input-item2">
      <div style="position:relative">
        <input
            type="text"
            class="phone"
            :class="{'error':codeMessage}"
            @blur="blurCode"
            @input="codeInput"
            v-model="code"
            placeholder="验证码"
        >
        <div class="jg"></div>
        <waterproof
            :judgeFunction="judgeFunction"
            :showPlugin="showPlugin"
            v-if="codeStaus==0||codeStaus==2"
            :CaptchaAppId="waterKey"
            :callback="callback"
            class="get-code"
            :title="codeTitle"
            :options="{needFeedBack: false}"
        ></waterproof>
        <div
            class="count-down"
            v-if="codeStaus==1"
        >{{ timeInfor }}
        </div>
      </div>
      <div class="bottom-tip">{{ codeMessage }}</div>
      <div class="reset-password">收不到验证码？
        <div class="tips">
          <p style="margin-bottom:6px;">收不到验证码可尝试以下方案：</p>
          <p>1.通信网络异常请重启手机</p>
          <p>2.查看手机设置-信息-黑名单</p>
          <p>3.检查是否有安全软件拦截了验证码</p>
        </div>
      </div>
    </div>
    <div
        class="login"
        @click.stop="toLogin"
    >登录
    </div>
    <div
        class="register"
        @click.stop="toRegister"
    >快速注册
    </div>
    <div class="jg"></div>
    <div class="user-infor">
      <span
          class="check-box"
          :class="{ active: isAccept }"
          @click="toggleClick"
      ></span>
      <div class="infor-content">
        <p>
          阅读并同意
          <a
              class="heightLight"
              href="https://www.speedtest.cn/terms"
              target="_blank"
          >《用户协议》</a>、
          <a
              class="heightLight"
              href="http://www.speedtest.cn/privacy"
              target="_blank"
          >《隐私政策》</a>和
        </p>
        <p><a
            class="heightLight"
            href="http://www.speedtest.cn/promise"
            target="_blank"
        >《产品使用承诺书》</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import {verifyPhone, verifyAccount, verifyPassword} from '@/utils/hooks/index'
import {getIdentifyingCode, messageLogin} from '@/api/login'
import store from '@/store/index'
import {waterKey} from '@/config/waterProofKey'

export default {
  props: {
    active: {
      type: Boolean
    },
    showRegister: {
      type: Boolean
    },
    isFirstLogin: {
      type: Boolean
    },
    loginScuess: {
      type: Boolean
    },
    firstLoginCode: {
      type: String
    },
    showSetInfor: {
      type: Boolean
    },
    isShowInfor: {
      type: Boolean
    }
  },
  data() {
    return {
      property: 'value',
      phoneMessage: '', //手机号错误提示信息
      codeMessage: '', //验证码
      phone: '',
      code: '', // 验证码
      codeTitle: '发送验证码', //获取验证码按钮的提示信息
      codeStaus: 0, //0 未发送验证码，1点击发送验证码 2发送完成可重复发送
      timer: null, //验证码倒计时
      timeInfor: '重新发送(60s)', //当时的计时时间
      showPlugin: false, //控制防水墙弹窗
      apiVersion: 'v1', //接口版本
      isAccept: false, //使用同意用户协议
      waterKey
    }
  },
  methods: {
    toggleClick() {
      this.isAccept = !this.isAccept
    },
    //验证账号输入失去焦点
    blurPhone() {
      if (!this.phone) {
        this.phoneMessage = '请输入手机号'
      } else {
        if (verifyPhone(this.phone)) {
          this.phoneMessage = ''
        } else {
          this.phoneMessage = '请输入正确格式手机号'
        }
      }
    },
    phoneInput() {
      if (this.phone) {
        this.phoneMessage = ''
      } else {
      }
    },
    //密码框失去焦点校验
    blurCode() {
      if (!this.code) {
        this.codeMessage = '请输入验证码'
      } else {
        this.codeMessage = ''
      }
    },
    codeInput() {
      if (this.code) {
        this.codeMessage = ''
      } else {
      }
    },
    //跳转注册页面
    toRegister() {
      //console.log(this.showRegister)
      this.$emit('update:showRegister', true)
    },
    //腾讯防水墙回调
    callback(res) {
      // 回调函数根据 ticket 和 errorCode （而非 ret）的情况做处理
      this.showPlugin = false
      if (res.ticket) {
        //根据errorCode情况做特殊处理
        if (res.errorCode) {
          //自定义容灾逻辑（例如跳过这次验证） 比如连续错误三次 刷新连续三次
        } else if (res.ret == 2 && !res.ticket) {
          //用户手动关闭
        } else {
          //发送成功
          //可以发送验证码
          this.timeInfor = '重新发送(60s)'
          this.timeDown(59)
          this.codeStaus = 1
          const {ticket, randstr} = res
          getIdentifyingCode({apiVersion: this.apiVersion, phone: this.phone,ticket, randStr:randstr})
              .then(res => {
                if (res.code == 200) {
                }
                res.code == 200 ? '' : (this.codeMessage = '验证码发送失败，请稍后重试')
              })
              .catch(err => {
                this.codeMessage = '验证码发送失败，请稍后重试'
              })
        }
      }
    },
    //显示弹窗前的校验逻辑
    judgeFunction() {
      //填写电话号码且号码格式正确
      if (this.phone && verifyPhone(this.phone)) {
        if (!this.isAccept) {
          this.$emit('update:isShowInfor', true)
          setTimeout(() => {
            this.$emit('update:isShowInfor', false)
          }, 2000)
          return
        }
        this.showPlugin = true
      } else {
        if (verifyPhone(this.phone)) {
          this.phoneMessage = '请输入正确的手机号'
        }
        if (!this.phone) {
          this.phoneMessage = '请输入手机号'
        }
      }
    },
    getCode() {
      //获取验证码
      //成功
      this.codeStaus = 2
      this.timeInfor = '重新发送(60s)'
      this.codeTitle = '重新发送'
      clearInterval(this.timer)
      this.timer = null
    },
    //验证码计时
    timeDown(time) {
      let item = time
      this.timer = setInterval(() => {
        if (item > 0 && item <= time) {
          this.timeInfor = `重新发送(${item--}s)`
        } else {
          this.codeStaus = 2
          this.codeTitle = '重新发送'
          this.timeInfor = '重新发送(60s)'
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    //登录
    toLogin() {
      if (!this.isAccept) {
        this.$emit('update:isShowInfor', true)
        setTimeout(() => {
          this.$emit('update:isShowInfor', false)
        }, 2000)
        return
      }
      this.blurCode()
      this.blurPhone()
      if (this.code && verifyPhone(this.phone)) {
        if (this.codeStaus) {
          let data = {
            clientId: '1',
            clientSecret: '123456',
            grantType: 'sms_code',
            tenantId: '0',
            phone: this.phone,
            code: this.code
          }
          messageLogin(data)
              .then(res => {
                if (res.code == 202) {
                  //必须填个人信息
                  this.$emit('update:showRegister', false)
                  this.$emit('update:isFirstLogin', true)
                  //this.$emit('update:loginScuess', true)
                  this.$emit('update:firstLoginCode', this.code)
                  this.$emit('update:firstLoginPhone', this.phone)
                  //this.msgSuccess('请填写个人信息')
                }
                if (res.code == 200) {
                  let data = res.data
                  this.$emit('update:showRegister', false)
                  this.$emit('update:loginScuess', true)
                  store.commit('login/setValue', [data.access_token, 'access_token'])
                  store.commit('login/setValue', [data.refresh_token, 'refresh_token'])
                  store.commit('login/setValue', [data.token_type, 'token_type'])
                  store.commit('login/setValue', [true, 'is_login'])
                  store.commit('login/setValue', [data, 'userInfor'])
                  //this.msgSuccess('登录成功')
                }
                if (res.code !== 200 && res.code !== 202) this.codeMessage = '注册失败，请稍后重试'
              })
              .catch(err => {
                this.codeMessage = err.errorMsg
                console.log(err)
              })
        } else {
          this.codeMessage = '请先获取验证码'
        }
      } else {
        return
      }
    }
    //修改input值
  },
  watch: {
    phone(val) {
      this.phone = this.phone.replace(/\s+/g, '')
    },
    code(val) {
      this.code = this.code.replace(/\s+/g, '')
    }
  }
}
</script>

<style lang="less" scoped>
.sms {
  .tip-infor {
    margin-top: 13px;
    height: 16px;
    line-height: 16px;
    font-weight: 400;
    color: #82889a;
    font-size: 11px;
    margin-bottom: 11px;
  }

  .input-item1 {
    height: 58px;

    .phone {
      width: 100%;
      height: 39px;
      border-radius: 4px;
      border: 1px solid #5b6189;
      display: block;
      background: rgba(11, 25, 66, 0.9);
      color: #ffffff;
      line-height: 39px;
      padding: 10px 16px 9px;
      box-sizing: border-box;

      &:focus {
        outline: none; //这个可以把原来的线去掉
        border: 1px solid #ddd;
      }

      &.error {
        border: 1px solid #ff564d;
      }
    }

    .bottom-tip {
      width: 200%;
      height: 38px;
      line-height: 38px;
      color: #ff564d;
      font-size: 20px;
      transform: scale(0.5);
      position: relative;
      top: -9.5px;
      left: -50%;
    }
  }

  .input-item2 {
    height: 68px;
    position: relative;

    .phone {
      width: 100%;
      height: 39px;
      border-radius: 4px;
      border: 1px solid #5b6189;
      display: block;
      background: rgba(11, 25, 66, 0.9);
      color: #ffffff;
      line-height: 39px;
      padding: 10px 16px 9px;
      padding-right: 113px;
      box-sizing: border-box;

      &:focus {
        outline: none; //这个可以把原来的线去掉
        border: 1px solid #ddd;
      }

      &.error {
        border: 1px solid #ff564d;
      }
    }

    .jg {
      position: absolute;
      width: 1px;
      height: 16px;
      top: 11px;
      right: 96px;
      background: #58658a;
    }

    .get-code {
      position: absolute;
      top: 10px;
      right: 48px;
      transform: translateX(50%);
      height: 19px;
      font-weight: 400;
      color: #ffffff;
      line-height: 19px;
      font-size: 13px;
      cursor: pointer;
    }

    .count-down {
      position: absolute;
      top: 10px;
      right: 48px;
      transform: translateX(50%);
      height: 19px;
      font-weight: 400;
      color: #82889a;
      line-height: 19px;
      font-size: 13px;
    }

    .bottom-tip {
      width: 200%;
      height: 58px;
      line-height: 58px;
      color: #ff564d;
      font-size: 20px;
      transform: scale(0.5);
      position: relative;
      top: -14.5px;
      left: -50%;
    }

    .reset-password {
      position: absolute;
      right: 0;
      bottom: 6px;
      cursor: pointer;
      color: #82ebff;
      line-height: 16px;
      font-size: 11px;

      .tips {
        display: none;
        position: absolute;
        left: -91px;
        top: -102px;
        height: 99px;
        width: 215px;
        background: url(@/assets/image/icon/tipInfor.png);
        background-size: 100%;
        padding: 10px 18px;
        padding-right: 0px;
        box-sizing: border-box;

        p {
          font-size: 11px;
          height: 16px;
          line-height: 16px;
          font-weight: 400;
          color: #fff;
        }
      }

      &:hover {
        text-decoration: underline;

        .tips {
          display: block;
        }
      }
    }
  }

  .login {
    height: 39px;
    background: #00d2fa;
    border-radius: 4px;
    line-height: 39px;
    text-align: center;
    font-weight: bold;
    color: #ffffff;
    font-size: 13px;
    cursor: pointer;
  }

  .register {
    margin-top: 13px;
    height: 16px;
    color: #82ebff;
    line-height: 16px;
    font-size: 11px;
    text-align: center;
    cursor: pointer;
  }
}

.jg {
  height: 1px;
  background: #82889a;
  opacity: 0.2;
  margin-top: 20px;
}

a {
  text-decoration: none;
}

a:hover,
a:visited,
a:link,
a:active {
  // 做到只设置一次，就可以使所有a标签的四种状态都和本身颜色保持一致，样式代码该怎么写
  color: #82ebff;
  cursor: pointer;
}

.heightLight {
  color: #82ebff;
  cursor: pointer;
}

.user-infor {
  position: relative;
  padding: 13px 0px 13px 21px;
  box-sizing: border-box;

  .check-box {
    width: 10px;
    height: 10px;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #979797;
    position: absolute;
    top: 15px;
    left: 0;
    cursor: pointer;

    &.active {
      background: url('@/assets/image/icon/allScreen.png') no-repeat center;
      background-size: 100%;
      border: none;
    }
  }

  .infor-content {
    p {
      height: 16px;
      line-height: 16px;
      font-size: 11px;
      font-weight: 500;
      color: #ffffff;
    }
  }
}
</style>
